<script lang="ts" setup>
import DiscountForm from '@/components/content/DiscountForm.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Discount } from '@/models/discounts.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();
const events = useEvents();

const discounts = computed<Discount[]>(() => store.state.cns.discounts);

const update = () => {
  store.dispatch(ContentStoreActions.GetDiscounts);
};

onMounted(() => {
  events.on(Event.UpdateContentItem, update);
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.UpdateContentItem, update);
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Initiative', key: 'initiative', width: '25%' },
  { title: 'Title', key: 'title', width: '30%' },
  { title: 'Used / Total Codes', key: 'codes', width: '20%' },
];

const editItem = (_: MouseEvent, rowData: { item: Discount }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(DiscountForm),
    data: rowData.item,
  });
};

const addItem = () => {
  const item: Discount = {
    id: -1,
    title: '',
    description: '',
    emailText: '',
    codes: [],
    initiative: null,
  };

  store.commit(Mutations.ShowDrawer, {
    component: markRaw(DiscountForm),
    data: item,
  });
};
</script>
<template>
  <v-container>
    <h2>Discounts for Initiatives <CurrentLanguage /></h2>

    <v-data-table
      density="compact"
      :headers="headers"
      :items="discounts"
      @click:row.prevent="editItem"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.initiative="{ item }">
        {{ item.initiative?.title }}
      </template>
      <template v-slot:item.codes="{ item }">
        {{ item.codes.filter((c) => c.used).length }} / {{ item.codes.length }}
      </template>
    </v-data-table>

    <v-btn color="success" @click="() => addItem()">Add Discount</v-btn>
  </v-container>
</template>
